'use client';

// Text links shown under the big CTA (Apple Pay / Google Pay, or Checkout): bold 18px
// Poppins, primary-gradient text with a gradient underline. Two actions share one line
// joined by a grey "or", e.g. "Checkout or Add to Bag".

const PRIMARY_GRADIENT = 'linear-gradient(to right, #F52F81 0%, #FD7468 100%)';

export interface WalletTextLinkProps {
  id: string;
  label: string;
  onClick: () => void;
  /** When set, renders a link (e.g. the bag's Shopify checkout URL) instead of a button. */
  href?: string;
  disabled?: boolean;
}

function WalletTextLink({ id, label, onClick, href, disabled }: WalletTextLinkProps) {
  const inner = (
    <>
      <span style={{ backgroundImage: PRIMARY_GRADIENT, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>
        {label}
      </span>
      <span aria-hidden="true" className="absolute inset-x-0 -bottom-0.5 h-[2px] rounded-full" style={{ backgroundImage: PRIMARY_GRADIENT }} />
    </>
  );
  const cls = 'relative font-primary text-[18px] font-semibold leading-tight';
  return href ? (
    <a
      id={id}
      href={disabled ? undefined : href}
      onClick={disabled ? (e) => e.preventDefault() : onClick}
      aria-disabled={disabled || undefined}
      className={`${cls} ${disabled ? 'pointer-events-none opacity-50' : ''}`}
    >
      {inner}
    </a>
  ) : (
    <button id={id} type="button" onClick={onClick} disabled={disabled} className={`${cls} disabled:cursor-not-allowed disabled:opacity-50`}>
      {inner}
    </button>
  );
}

export default function WalletTextLinks({
  links,
  className = '',
}: {
  links: [WalletTextLinkProps] | [WalletTextLinkProps, WalletTextLinkProps];
  className?: string;
}) {
  return (
    <div className={`flex flex-wrap items-baseline justify-center gap-x-2 gap-y-2 ${className}`}>
      <WalletTextLink {...links[0]} />
      {links[1] && (
        <>
          <span className="font-primary text-[18px] font-semibold leading-tight text-[#828282]">or</span>
          <WalletTextLink {...links[1]} />
        </>
      )}
    </div>
  );
}
